import { render, staticRenderFns } from "./HelpEmblavementsComponent.vue?vue&type=template&id=11627bac"
import script from "./HelpEmblavementsComponent.vue?vue&type=script&lang=js"
export * from "./HelpEmblavementsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports